export default __webpack_public_path__ + "static/media/tcp.45e9eb73.png";